<footer class="bg-app-secondary py-3">
  <section class="container-fluid container-md">
    <div class="row">
      <!-- Contact Form: Start -->
      <section class="col-12 col-md-6" style="visibility: hidden">
        <h3>Contact Us</h3>
        <form>
          <div class="mb-3">
            <input type="email" class="form-control rounded-0" placeholder="hello@shopbrandnew.com">
          </div>
          <div class="mb-3">
            <textarea class="form-control rounded-0" rows="3"></textarea>
          </div>

          <div>
            <button class="btn app-btn-white">Send</button>
          </div>
        </form>
      </section>
      <!-- Contact Form: End -->

      <!-- Social Icons -->
      <section class="col-12 col-md-6 d-flex">
        <div class="row flex-fill align-content-end justify-content-end">
          <div class="col-12 col-md-9 col-lg-6">
            <div class="follow-us d-flex">
              <p class="fw-bold">
                Follow Us:
              </p>
              <a href="https://instagram.com/brandnew.india?utm_medium=copy_link" target="_blank"><i
                  class="bi bi-instagram"></i></a>
              <a href="https://www.facebook.com/BrandNew-104951002028087" target="_blank"><i
                  class="bi bi-facebook"></i></a>
              <a href="https://pin.it/5AvG8yj" target="_blank"><i class="bi bi-pinterest"></i></a>
              <a href="https://twitter.com/BrandNew_India" target="_blank"><i class="bi bi-twitter"></i></a>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</footer>
